<moorl-animation-field v-model:item="element.config.moorlAnimation.value"/>